<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<plant-select />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000337')" paramKey="msgKey" />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000338')" paramKey="msgText" />
				</el-col>
				<el-col :span="5">
					<msgLoc-select @reload="searchList()" />
				</el-col>
				<el-col :span="5">
					<msgType-select @reload="searchList()" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
import PlantSelect from './PlantSelect.vue';
import MsgTypeSelect from './MsgTypeSelect.vue';
import MsgLocSelect from './MsgLocSelect.vue';
import SearchInput from './SearchInput.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect, MsgTypeSelect, MsgLocSelect, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 30) {
			this.$sf_toggleLoading(true);
			this.getDicMsgManagements_({ currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.getPlants_()
			.then(value => {
				this.searchList();
				this.getCommCodes_({ key: 'langs', codeType: 'LANG' }).catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				});
				this.getCommCodes_({ key: 'msgTypes', codeType: 'MSG_TYPE' })
					.then(() => {
						this.msgTypes.forEach(row => {
							this.gridMsgTypes.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					});
				this.getCommCodes_({ key: 'msgLocs', codeType: 'SYSTEM' })
					.then(() => {
						this.msgLocs.forEach(row => {
							this.gridMsgLocs.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					});
				//공통화
				this.getCommCodes_({ key: 'msgId', codeType: 'MSG_KEY_TYPE' })
					.then(() => {
						this.msgId.forEach(row => {
							this.gridMsgID.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
	},
	watch: {
		langCd() {
			this.resetYnState_();
			this.getCommCodes_({ key: 'langs', codeType: 'LANG' }).catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
			this.getCommCodes_({ key: 'msgTypes', codeType: 'MSG_TYPE' })
				.then(() => {
					this.msgTypes.forEach(row => {
						this.gridMsgTypes.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				});
			this.getCommCodes_({ key: 'msgLocs', codeType: 'SYSTEM' })
				.then(() => {
					this.msgLocs.forEach(row => {
						this.gridMsgLocs.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				});
			//공통화
			this.getCommCodes_({ key: 'msgId', codeType: 'MSG_KEY_TYPE' })
				.then(() => {
					this.msgId.forEach(row => {
						this.gridMsgID.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				});
		}
	}
};
</script>

<style></style>
